class GrabToScroll extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        display: block;
        overflow: auto;

        -ms-overflow-style: none;
        scrollbar-width: none;
      }

      :host[data-cursor="grab"] {
        cursor: grab;
      }

      :host[active] {
        cursor: grabbing;
      }

      :host::-webkit-scrollbar {
        display: none;
      }
    `
  }

  connectedCallback () {
    super.connectedCallback()

    this.isDown = false
    this.startX = null
    this.previousScrollLeft = null

    this.setAttribute(
      'data-cursor',
      this.scrollWidth > this.offsetWidth ? 'grab' : 'initial',
    )

    this.toggleAttribute(
      'ended',
      this.scrollWidth - this.clientWidth === this.scrollLeft,
    )
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', this.handleClick.bind(this))
    this.listeners.add(this, 'mousedown', this.handleMouseDown.bind(this))
    this.listeners.add(this, 'mouseleave', this.handleMouseLeave.bind(this))
    this.listeners.add(this, 'mouseup', this.handleMouseUp.bind(this))
    this.listeners.add(this, 'mousemove', this.handleMouseMove.bind(this))
    this.listeners.add(this, 'scroll', this.handleScroll.bind(this))

    this.debouncedHandleScrollEnd = window.BAO.utils.debounce(
      e => this.handleScrollEnd(e),
      150,
    )

    this.listeners.add(this, 'scroll', this.handleScroll.bind(this))
    this.listeners.add(this, 'scroll', this.debouncedHandleScrollEnd.bind(this))
  }

  handleScroll () {
    if (this.hasAttribute('scrolling')) return
    this.toggleAttribute('scrolling', true)
  }

  handleScrollEnd () {
    this.toggleAttribute('scrolling', false)
    this.toggleAttribute(
      'ended',
      this.scrollWidth - this.clientWidth === this.scrollLeft,
    )
  }

  handleClick (event) {
    if (this.hasAttribute('disable-click')) {
      event.preventDefault()
      this.toggleAttribute('disable-click', false)
    }
  }

  handleMouseDown (event) {
    event.preventDefault()
    if (this.hasAttribute('disable-grab')) return

    this.isDown = true
    this.toggleAttribute('active', true)
    this.startX = event.pageX - this.offsetLeft
    this.previousScrollLeft = this.scrollLeft
  }

  handleMouseLeave () {
    this.isDown = false
    this.toggleAttribute('active', false)
    this.toggleAttribute('disable-click', false)
  }

  handleMouseUp () {
    this.isDown = false
    this.toggleAttribute('active', false)
  }

  handleMouseMove (event) {
    if (!this.isDown) return
    event.preventDefault()
    const x = event.pageX - this.offsetLeft
    const walk = (x - this.startX) * 1.2
    this.scrollLeft = this.previousScrollLeft - walk
    this.toggleAttribute('disable-click', true)
  }
}

if (!customElements.get('grab-scroll')) {
  customElements.define('grab-scroll', GrabToScroll)
}
